<template>
  <div class="user-profile">
    <h2>个人资料</h2>
    
    <div class="profile-info">
      <h3>基本信息</h3>
      <div class="info-item">
        <label>用户ID:</label>
        <span>{{ currentUser.id }}</span>
      </div>
      <div class="info-item">
        <label>用户名:</label>
        <span>{{ currentUser.username }}</span>
      </div>
      <div class="info-item">
        <label>邮箱:</label>
        <span>{{ currentUser.email }}</span>
      </div>
    </div>
    
    <div class="change-password">
      <h3>修改密码</h3>
      <form @submit.prevent="changePassword">
        <div class="form-group">
          <label for="currentPassword">当前密码:</label>
          <input type="password" id="currentPassword" v-model="passwordForm.currentPassword" required>
        </div>
        
        <div class="form-group">
          <label for="newPassword">新密码:</label>
          <input type="password" id="newPassword" v-model="passwordForm.newPassword" required>
        </div>
        
        <div class="form-group">
          <label for="confirmPassword">确认新密码:</label>
          <input type="password" id="confirmPassword" v-model="passwordForm.confirmPassword" required>
        </div>
        
        <button type="submit" :disabled="changingPassword">
          {{ changingPassword ? '修改中...' : '修改密码' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'

export default {
  name: 'UserProfilePage',
  data() {
    return {
      currentUser: {},
      changingPassword: false,
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  mounted() {
    this.loadUserProfile()
  },
  methods: {
    loadUserProfile() {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user) {
        this.currentUser = user
      }
    },
    
    changePassword() {
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        alert('新密码和确认密码不匹配')
        return
      }
      
      this.changingPassword = true
      const user = JSON.parse(localStorage.getItem('user'))
      
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      
      if (user && user.token) {
        config.headers['Authorization'] = `Bearer ${user.token}`
      }
      
      // 构造更新用户密码的数据
      const userData = {
        id: this.currentUser.id,
        username: this.currentUser.username,
        email: this.currentUser.email,
        password: this.passwordForm.newPassword
      }
      
      api.put(`/users/${this.currentUser.id}`, userData, config)
        .then(() => {
          this.changingPassword = false
          this.passwordForm = {
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          }
          alert('密码修改成功!')
        })
        .catch(error => {
          console.error('修改密码失败:', error)
          this.changingPassword = false
          alert('修改密码失败: ' + (error.response?.data?.message || '未知错误'))
        })
    }
  }
}
</script>

<style scoped>
.user-profile {
  padding: 20px;
}

.profile-info {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 30px;
}

.profile-info h3 {
  margin-top: 0;
}

.info-item {
  display: flex;
  margin-bottom: 10px;
}

.info-item label {
  font-weight: bold;
  width: 100px;
}

.change-password {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
}

.change-password h3 {
  margin-top: 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}
</style>